import * as React from "react";
import type { SVGProps } from "react";
const SvgNetwork = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M14 6c0 .288.03.57.088.84L9.02 9.376A3.999 3.999 0 0 0 2 12a3.999 3.999 0 0 0 7.02 2.625l5.07 2.534A3.999 3.999 0 0 0 18 22c2.209.001 3.999-1.789 3.999-3.999a3.999 3.999 0 0 0-7.016-2.628l-5.071-2.536a4.02 4.02 0 0 0 0-1.672l5.07-2.536A3.999 3.999 0 0 0 22 6c.001-2.21-1.789-4-3.999-4s-4 1.79-4 4Zm2 0c0-1.1.9-2 2-2s2 .9 2 2-.9 2-2 2-2-.9-2-2ZM6 10c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2Zm12 6c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2Z"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgNetwork;
